export default {
  methods: {
    scrollTo(id, offset = -30) {
      var t = this;

      setTimeout(function() {
        t.$scrollTo(id, 300, {
          offset
        });
      }, 400);
    },

    removeBodyOverflow() {
      document.querySelector("body").style.overflow = "hidden";
    },
    addBodyOverflow() {
      document.querySelector("body").style.overflow = "auto";
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/scrollMixin.js